import type { ReactNode } from "react";
import { Icon } from "./Icon";

/** 折りたたみの開閉を示すシェブロン。開くと下向きに回転する。 */
export function DisclosureChevron({ open, size }: { open: boolean; size: number }) {
	return (
		<span className="izanagi-disclosure-chevron" data-open={open}>
			<Icon name="chevronR" size={size} color="var(--fg-3)" />
		</span>
	);
}

/** メニュー開閉ボタンのシェブロン。開くと上向きに回転する。 */
export function DropdownChevron({
	open,
	size,
	color,
}: {
	open: boolean;
	size: number;
	color: string;
}) {
	return (
		<span className="izanagi-dropdown-chevron" data-open={open}>
			<Icon name="chevronD" size={size} color={color} />
		</span>
	);
}

/** 折りたたみの中身。マウント時に高さを伸ばして現れる。自動で開くときは animate を false にする。 */
export function ExpandIn({
	animate = true,
	className = "",
	children,
}: {
	animate?: boolean;
	className?: string;
	children: ReactNode;
}) {
	return (
		<div className={`${animate ? "izanagi-expand" : "min-w-0"} ${className}`}>
			<div>{children}</div>
		</div>
	);
}
